import { ActionButton } from '../../utils/action-button/actionButton';
import './wallet.scss';

import React from "react"

export const WalletSetter : React.FC = () => {

    const wallet    = true;

    const handleAddWallet = () => {

    }

    return (
        <div className="wallet-wrapper">

            <h1>Configuração de Wallet</h1>
            
            <div className="card">
                <div className="card-header">
                    Informações: Ao adicionar uma wallet, por questões de segunrança,  essa conta de celular será vinculado a essa carteira e não poderá ser alterada, pedidos que verifique a wallet antes de vinvular.
                </div>
                <div className="caardbody">
                    <p>Dicas:</p>
                    <ul>
                        <li>Apenas 1 wallet por conta, verifique a wallet antes de vincular</li>
                        <li>De nenhuma maneira ela será alterada</li>
                        <li>Não precisa se identificar</li>
                        <li>Utilizamos a rede TRON, de preferencia, mas aceitamos outras</li>
                    </ul>
                </div>
            </div>

            <hr />

            <div className="form">
                <legend>Digite a baixo a carteira que será vinculada a essa conta:</legend>
                <div className="input-wrapper">
                    <input type="text" id="wallet" placeholder='Hash da wallet: Ex 0xfe32f....e323'/>
                </div>
                <ActionButton 
                    label='Gerar QR Code' 
                    stylish='btn-green' 
                    minimal='minimal'
                    onClick={handleAddWallet}
                    disabled={!wallet}/>
            </div>
        </div>
    )
}